export enum SupportedPaymentMethod {
    ApplePay = 'ApplePay',
    GooglePay = 'GooglePay',
    Ideal = 'Ideal',
    PaymentCard = 'PaymentCard',
    SepaDirectDebit = 'SepaDirectDebit',
}
